
import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  watch,
} from "vue";
import { documentService, PostDocument } from "@/services";
import { ValidationErrors } from "@/utils/form";
import Litepicker from "@/global-components/litepicker/Main.vue";
import { useRoute } from "vue-router";
import VueTiptap from "@/components/tiptap/Main.vue";
import { helper } from "@/utils/helper";

export default defineComponent({
  name: "NDocumentProperties",
  components: { VueTiptap, Litepicker },
  props: {
    state: { type: Object, default: () => ({}) },
    formData: { type: Object as () => PostDocument, default: () => ({}) },
    validationErrors: {
      type: Object as () => ValidationErrors,
      default: () => ({}),
    },
  },
  setup(props) {
    const route = useRoute();
    const versionUUID = computed(() => _.get(route.query, "v", ""));

    const editableState = reactive(toRefs<Record<string, any>>(props.state));
    const editableFormData = reactive(toRefs<PostDocument>(props.formData));
    const nextNumber = reactive<Record<string, any>>({
      loading: false,
      value: 0,
    });
    const fetchNextNumber = () => {
      nextNumber.loading = true;
      documentService
        .fetchNextNumber({
          committee_id: editableFormData.committee_id,
          language: editableFormData.language,
          n_number: props.state.n_number,
        })
        .then((result) => {
          if (result.kind === "ok") {
            nextNumber.value = result.data.n_number;
            if (editableFormData.is_n_document) {
              editableFormData.n_number = result.data.n_number;
              editableFormData.version = result.data.version;
            }
          }
        })
        .finally(() => {
          nextNumber.loading = false;
        });
    };
    onMounted(() => {
      if (!versionUUID.value) {
        fetchNextNumber();
      }
      if (!editableFormData.document_date) {
        editableFormData.document_date = helper.formatDate(new Date(), "YYYY-MM-DD")
      }
    });
    watch(
      computed(() => [
        editableFormData.committee_id,
        editableFormData.language,
      ]),
      () => {
        if (editableFormData.is_n_document) {
          fetchNextNumber();
        }
      },
      { deep: true }
    );

    const documentSelect2Options = computed(() => ({
      ajaxQuery: {
        document: {
          "@pagination": 15,
          "@select": {
            value: "id",
            text: "title",
            n_number: "n_number",
            uuid: "uuid",
            version: "version",
          },
          "@order": ["n_number:desc", "version:desc"],
          "@where": {
            committee_id: editableFormData.committee_id,
          },
          "@whereNotIn": {
            n_number: [null, "", "null", "0"],
          },
        },
      },
      templateSelection(obj: any): any {
        if (obj.n_number) return `(N${obj.n_number || ""}) ${obj.text}`;
        return obj.text;
      },
    }));

    const onChangeReplace = (ctx: Record<string, any>): void => {
      editableState.replace = ctx;
    };

    const onChangeNoteJson = (val: any): void => {
      editableState.noteJsonData = _.get(val, "content", []);
    };

    return {
      editableFormData,
      nextNumber,
      documentSelect2Options,
      onChangeReplace,
      onChangeNoteJson,
    };
  },
});
